import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\AttachmentCategoryController::undo
* @see app/Http/Controllers/AttachmentCategoryController.php
* @route '/api/attachment-category/undo-delete/{id}'
*/
export const undo = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/attachment-category/undo-delete/{id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AttachmentCategoryController::undo
* @see app/Http/Controllers/AttachmentCategoryController.php
* @route '/api/attachment-category/undo-delete/{id}'
*/
undo.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undo.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AttachmentCategoryController::undo
* @see app/Http/Controllers/AttachmentCategoryController.php
* @route '/api/attachment-category/undo-delete/{id}'
*/
undo.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AttachmentCategoryController::undo
* @see app/Http/Controllers/AttachmentCategoryController.php
* @route '/api/attachment-category/undo-delete/{id}'
*/
undo.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AttachmentCategoryController::index
* @see app/Http/Controllers/AttachmentCategoryController.php
* @route '/api/attachment-category'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/api/attachment-category',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AttachmentCategoryController::index
* @see app/Http/Controllers/AttachmentCategoryController.php
* @route '/api/attachment-category'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AttachmentCategoryController::index
* @see app/Http/Controllers/AttachmentCategoryController.php
* @route '/api/attachment-category'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AttachmentCategoryController::index
* @see app/Http/Controllers/AttachmentCategoryController.php
* @route '/api/attachment-category'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AttachmentCategoryController::store
* @see app/Http/Controllers/AttachmentCategoryController.php
* @route '/api/attachment-category'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/api/attachment-category',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AttachmentCategoryController::store
* @see app/Http/Controllers/AttachmentCategoryController.php
* @route '/api/attachment-category'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AttachmentCategoryController::store
* @see app/Http/Controllers/AttachmentCategoryController.php
* @route '/api/attachment-category'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AttachmentCategoryController::update
* @see app/Http/Controllers/AttachmentCategoryController.php
* @route '/api/attachment-category/{attachment_category}'
*/
export const update = (args: { attachment_category: string | number } | [attachment_category: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '/api/attachment-category/{attachment_category}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\AttachmentCategoryController::update
* @see app/Http/Controllers/AttachmentCategoryController.php
* @route '/api/attachment-category/{attachment_category}'
*/
update.url = (args: { attachment_category: string | number } | [attachment_category: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { attachment_category: args }
    }

    if (Array.isArray(args)) {
        args = {
            attachment_category: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        attachment_category: args.attachment_category,
    }

    return update.definition.url
            .replace('{attachment_category}', parsedArgs.attachment_category.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AttachmentCategoryController::update
* @see app/Http/Controllers/AttachmentCategoryController.php
* @route '/api/attachment-category/{attachment_category}'
*/
update.put = (args: { attachment_category: string | number } | [attachment_category: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\AttachmentCategoryController::update
* @see app/Http/Controllers/AttachmentCategoryController.php
* @route '/api/attachment-category/{attachment_category}'
*/
update.patch = (args: { attachment_category: string | number } | [attachment_category: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\AttachmentCategoryController::destroy
* @see app/Http/Controllers/AttachmentCategoryController.php
* @route '/api/attachment-category/{attachment_category}'
*/
export const destroy = (args: { attachment_category: string | number } | [attachment_category: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/api/attachment-category/{attachment_category}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\AttachmentCategoryController::destroy
* @see app/Http/Controllers/AttachmentCategoryController.php
* @route '/api/attachment-category/{attachment_category}'
*/
destroy.url = (args: { attachment_category: string | number } | [attachment_category: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { attachment_category: args }
    }

    if (Array.isArray(args)) {
        args = {
            attachment_category: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        attachment_category: args.attachment_category,
    }

    return destroy.definition.url
            .replace('{attachment_category}', parsedArgs.attachment_category.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AttachmentCategoryController::destroy
* @see app/Http/Controllers/AttachmentCategoryController.php
* @route '/api/attachment-category/{attachment_category}'
*/
destroy.delete = (args: { attachment_category: string | number } | [attachment_category: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const AttachmentCategoryController = { undo, index, store, update, destroy }

export default AttachmentCategoryController